import type {
  MatchingBoardPageDto,
  MatchingEventViewDto,
  MatchingMetaDto,
  MatchingPanelDayDto,
  MatchingRequestCommand,
  MatchingRequestDto,
  MatchingRestoreDto,
  MatchingStatusDto,
  MatchingWindowDto,
} from '../api/matchingTypes';
import { endpoints } from '../api/sharedEndpoints';

export interface MatchingRepository {
  getStatus(): Promise<MatchingStatusDto>;
  setStatus(params: { enabled: boolean }): Promise<MatchingStatusDto>;
  getMeta(): Promise<MatchingMetaDto>;
  preview(params: { command: MatchingRequestCommand }): Promise<MatchingWindowDto>;
  create(params: { command: MatchingRequestCommand }): Promise<MatchingRequestDto>;
  update(params: {
    id: number;
    version: number;
    command: MatchingRequestCommand;
  }): Promise<MatchingRequestDto>;
  cancel(params: { id: number }): Promise<void>;
  copy(params: { id: number }): Promise<MatchingRequestDto>;
  restore(params: { id: number }): Promise<MatchingRestoreDto>;
  getBoard(params: {
    from?: string;
    to?: string;
    page: number;
    size: number;
  }): Promise<MatchingBoardPageDto>;
  getPanel(params: { from?: string; to?: string }): Promise<MatchingPanelDayDto[]>;
  getEventViews(params: { eventIds: number[] }): Promise<MatchingEventViewDto[]>;
}

export class ApiMatchingRepository implements MatchingRepository {
  getStatus() {
    return endpoints.getMatchingStatus();
  }

  setStatus(params: { enabled: boolean }) {
    return endpoints.setMatchingStatus(params.enabled);
  }

  getMeta() {
    return endpoints.getMatchingMeta();
  }

  preview(params: { command: MatchingRequestCommand }) {
    return endpoints.previewMatchingRequest(params.command);
  }

  create(params: { command: MatchingRequestCommand }) {
    return endpoints.createMatchingRequest(params.command);
  }

  update(params: { id: number; version: number; command: MatchingRequestCommand }) {
    return endpoints.updateMatchingRequest(params.id, params.version, params.command);
  }

  cancel(params: { id: number }) {
    return endpoints.cancelMatchingRequest(params.id);
  }

  copy(params: { id: number }) {
    return endpoints.copyMatchingRequest(params.id);
  }

  restore(params: { id: number }) {
    return endpoints.restoreMatchingRequest(params.id);
  }

  getBoard(params: { from?: string; to?: string; page: number; size: number }) {
    return endpoints.getMatchingBoard(params);
  }

  getPanel(params: { from?: string; to?: string }) {
    return endpoints.getMatchingPanel(params);
  }

  getEventViews(params: { eventIds: number[] }) {
    return endpoints.getMatchingEventViews(params.eventIds);
  }
}
